import { Dialog, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { EXTERNAL_LINKS } from '../../constants/links';

const VideoDialog = ({ open, onClose }) => {
  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '60vw',
          height: '60vh',
          maxWidth: 'none',
          m: 0
        }
      }}
    >
      <IconButton
        sx={{ position: 'absolute', right: 8, top: 8, color: 'white', zIndex: 1 }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
        <iframe
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
          src={`${EXTERNAL_LINKS.video}?autoplay=1&controls=0&modestbranding=1&rel=0&showinfo=0&iv_load_policy=3&disablekb=1`}
          title="Paradise Tycoon Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Box>
    </Dialog>
  );
};

export default VideoDialog; 